<template>
    <nav v-show="menuVisible" class="nav">
        <ul class="nav__menu">
            <li class="py-0">
                <v-select
                    v-model="select"
                    :items="databaseMenuItems"
                    solo
                    append-icon=""
                    class="nav-select"
                    attach
                    full-width
                    @change="routeChange($event)"
                >
                    <template
                        slot-scope="{ item }"
                        slot="selection"
                    >
                        <router-link :to="{name:'database', hash: item.value}" class="link link--dark">
                            <div @click.native="HIDE_MENU()">{{ item.text }}</div>
                        </router-link>
                    </template>
                    <template #append>
                      <v-icon aria-hidden="true" translate="no">
                        expand_more
                      </v-icon>
                    </template>
                </v-select>
            </li>
            <li v-for="(item, i) in accessed_menu" :key="i">
                <router-link :to="{name:item.link}" class="link link--dark">
                    <div @click.native="HIDE_MENU()">{{ $t(item.text) }}</div>
                </router-link>
            </li>
        </ul>
        <div class="nav__icons">
            <div v-for="(item, i) in icons" :key="i"
                 ref="ref_icon"
                 class="nav__icons-item"
                 :class="{
                     'notification-icon-basket': item.name === 'basket' && count > 0,
                     'notifications notification-icon-requests': item.name === 'notifications' && push_notifications_active_count > 0,
                     'notifications': item.name === 'notifications' && push_notifications_active_count === 0,
                     '': item.name === 'calendar'
                 }"
                 :data-notification-count="item.name === 'notifications' ? push_notifications_active_count : count"
                 @click="open(item)"
            >
                <a href="#">
                    <svg v-svg
                         v-if="item.permission"
                         :symbol="item.name"
                         size="32"
                         class="icon"
                         role="presentation"
                    />
                </a>
                <v-dialog ref="modal" :value="item.name!='calendar' ? item.active : calendar_showed"
                          :class="{'modal_calendar': item.name == 'calendar'}"
                          :content-class="item.name == 'notifications' ? 'scrolled-dialog' : ''"
                >
                    <component v-if="item.name!='calendar' ? item.active : calendar_showed"
                               ref="modal_window"
                               :active="item.name!='calendar' ? item.active : calendar_showed"
                               @close="close(item)"
                               :is="item.modal"
                    />
                </v-dialog>
            </div>
            <router-link to="/favourites">
                <svg v-svg
                     symbol="favorites"
                     size="32"
                     class="icon"
                     role="presentation"
                     @click="HIDE_MENU()"
                />
            </router-link>
        </div>

        <ul class="nav__menu">
            <li class="py-0">
                <v-select
                    :value="lang"
                    :items="langs"
                    solo
                    append-icon=""
                    item-text="text"
                    item-value="code"
                    class="nav-select"
                    :placeholder="lang ? undefined : lang"
                    attach
                    full-width
                    @change="changeLang($event)"
                >
                    <template
                        slot-scope="{ item, index }"
                        slot="selection"
                    >
                        <div @click.native="HIDE_MENU()">{{ item.text }}</div>
                    </template>
                    <template #append>
                      <v-icon aria-hidden="true" translate="no">
                        expand_more
                      </v-icon>
                    </template>
                </v-select>
            </li>
        </ul>

        <div class="nav__icons-item nav__burger mr-0" :class="{'mr-0': $vuetify.breakpoint.xs}" @click="TOGGLE_MENU()">
            <a href="#">
                <svg v-svg
                     :symbol="menu_showed ? 'close' : 'burger'"
                     size="32"
                     class="icon"
                     :class="menu_showed ? 'red-text' : ''"
                     role="presentation"
                     @click.native="open(item)"
                />
            </a>
        </div>
    </nav>
</template>

<script>
import Icon from '@/components/ui/icons/icon';
import darkLink from '@/components/ui/links/styled/link_dark';
import modalNote from '@/components/blocks/common/notifications_modal';
import modalCalendar from '@/components/blocks/common/calendar';
import {mapMutations, mapGetters, mapActions} from 'vuex';
import REGION_CODES from '@/configs/region_codes';

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this;
    let args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}


export default {
  components: {
    Icon,
    darkLink,
    modalCalendar,
    modalNote,
  },
  props: {
    menuVisible: {
      type   : Boolean,
      default: true,
    },
  },
  data() {
    return {
      top           : '',
      data_item     : {},
      // dialog: false,
      tooltip_height: 0,
      tooltip_width : 0,
      notif_opened  : false,
      menu          : [],
      icons         : [
        {
          name      : 'calendar',
          permission: !!JSON.parse(localStorage.getItem('user')).role.calendar_courses.rights.length,
          active    : this.calendar_showed,
          modal     : modalCalendar,
        },
        {name: 'basket', permission: true, active: false, modal: false},
        {name: 'notifications', permission: true, active: false, modal: modalNote},
      ],
      database_menu: [],
      select       : '',
    };
  },
  computed: {
    accessed_database_menu() {
      return this.database_menu.filter((menuItem) => menuItem.permissions);
    },
    accessed_menu() {
      return this.menu.filter((menuItem) => menuItem.permissions);
    },
    // ...mapGetters('notifications/Notifications_items', [
    // 'push_notifications_active',
    // 'push_notifications_active_count',
    // ]),
    databaseMenuItems() {
      return this.accessed_database_menu.map((item) => ({
        ...item,
        text: this.$t(item.text),
      }));
    },
    ...mapGetters('calendar', [
      'menu_showed', 'calendar_showed',
    ]),
    ...mapGetters('profile/user', [
      'user_id',
      'user',
    ]),
    ...mapGetters('notifications/Notifications_items', [
      'notifications',
      'push_notifications_active_count',
    ]),
    ...mapGetters('order/Basket', ['count']),
    ...mapGetters('profile/general', [
      'langs',
      'lang',
    ]),
  },
  mounted() {
    this.database_menu = [
      {
        text       : 'База знаний',
        value      : '',
        permissions: true,
      },
      {
        text       : this.user.region_code === REGION_CODES.BITUM_MATERIALS ? 'Методические материалы' : 'Международные классификации',
        value      : '#classification',
        permissions: true,
      },
      {
        text       : 'Продуктовый портфель',
        value      : '#product',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text       : 'Одобрения ОЕМ',
        value      : '/#oem',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text       : 'Глоссарий',
        value      : '#glossary',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
    ];
    this.menu = [
      {
        text       : 'Новости и мероприятия',
        link       : 'news_main',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      // {
      //   text: 'Банк идей',
      //   link: 'ideas_bank',
      // },
      // {
      //   text: 'Живая лента',
      //   link: 'live_news',
      // },
      {
        text       : 'Вопрос-ответ',
        link       : 'faq',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text       : 'Мои заказы',
        link       : 'prize_order',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
    ];
    let myEfficientFn = debounce(() => {
      if (this.data_item) {
        this.get_coordinates(this.data_item);
      }
      // All the taxing stuff you do
    }, 250);

    const basket = localStorage.getItem('basket');
    this.getBasket(basket);

    window.addEventListener('resize', myEfficientFn);

    this.get_notifications();
  },
  methods: {
    ...mapMutations('calendar', [
      'TOGGLE_MENU',
      'HIDE_MENU',
      'OPEN_CALENDAR',
      'CLOSE_CALENDAR',
    ]),
    ...mapActions('order/Basket', ['getBasket']),
    ...mapActions('notifications/Notifications_items', ['get_notifications']),
    ...mapActions('profile/general', ['update_language']),
    get_ofset(el) {
      if (el && el[0]) {
        const rect = el[0].getBoundingClientRect();
        return {
          left: rect.left + window.pageXOffset,
          top : rect.top + window.pageYOffset,
        };
      }
    },
    async get_coordinates(item) {
      // this.set_coord(item);
      const coord = {};
      const element = document.getElementsByClassName('nav__icons-item ' + item.name);
      if (this.data_item.name) {
        coord.left = this.get_ofset(element).left;
        coord.top = this.get_ofset(element).top;
        let btn_height;
        setTimeout(() => {
          const modal = item.name == 'notifications' ? document.getElementsByClassName('calendar-modal') :
              document.getElementsByClassName('v-dialog v-dialog--active');
          let modal_width = 0;
          btn_height = document.getElementsByClassName('modal-btn')[0].clientHeight;
          if (modal[0]) {
            modal_width = modal[0].offsetWidth;
          }
          const btn = document.getElementsByClassName('modal-btn');
          btn[0].style.right = '0';
          if (item.name == 'notifications') {
            document.getElementsByClassName('calendar-modal')[0].style.margin = 0;
          }
          modal[0].style.position = 'absolute';
          {
            modal[0].style.left = coord.left - modal_width + 40 + 'px';
            modal[0].style.top = btn_height + 'px';
            btn[0].style.top = (-btn_height) + 'px';
          }
        }, 100);
      }
    },
    async open(item) {
      if (item.name == 'basket') {
        this.$router.push({name: 'prize_basket'});
        item.active = false;
      } else if (item.name == 'calendar') {
        this.OPEN_CALENDAR();
      } else {
        item.active = true;
      }

      if (item.name == 'notifications') {
        await this.get_notifications();
      }
      this.data_item = item;
      this.get_coordinates(item);
    },
    close(item) {
      if (item.name == 'calendar') {
        this.CLOSE_CALENDAR();
      } else {
        item.active = false;
      }
    },
    routeChange(hash) {
      this.$router.push({name: 'database', hash});
    },
    async changeLang(lang) {
      let code = lang.code || lang;
      let langObj = this.langs.filter((item) => item.code == code);

      await this.update_language({lang: langObj[0]});
      this.$router.go();
    },
  },
};
</script>

<style scoped>
.notification-icon-basket::before {
  content: attr(data-notification-count);
  text-align: center;
  font-size: 10px;
  color: white;
  line-height: 23px;
  display: block;
  width: 20px;
  height: 20px;
  background-color: #e2173d;
  border-radius: 50%;
  position: absolute;
  right: -2px;
  z-index: 2;
}
</style>
